import React, { useState } from "react"
import ModalDeleteCompany from "../../../../Modal/ModalDeleteCompany"
import ModalEditCompanyStatus from "../../../../Modal/ModalEditCompanyStatus"
import { parseB3Table } from "./helpers/parseB3Table"
import "./../../AllCompanysTable.css"
import CustomTable from "components/Common/CustomTable"

const B3Table = ({
  dataArray,
  currentPage,
  onPageChange,
  setCompanySelected,
  setShowList,
  totalPages,
}) => {
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false)
  const [isModalEditStatusOpen, setIsModalEditStatusOpen] = useState(false)
  const [companyToEdit, setCompanyToEdit] = useState()

  const handleSelectCompanyToEditStatus = company => {
    setCompanyToEdit(company)
    setIsModalEditStatusOpen(true)
  }

  const handleSelectCompanyToDelete = company => {
    setCompanyToEdit(company)
    setIsModalDeleteOpen(true)
  }

  const handleSelectCompany = company => {
    setCompanySelected(company)
    setShowList(null)
  }

  return (
    <div className="company-table-container">
      {isModalDeleteOpen && (
        <ModalDeleteCompany
          companyId={companyToEdit.Id}
          urlTo={"b3"}
          setIsModalOpen={setIsModalDeleteOpen}
          setCurrentPage={onPageChange}
        />
      )}

      {isModalEditStatusOpen && (
        <ModalEditCompanyStatus
          urlTo={"b3"}
          setCurrentPage={onPageChange}
          setIsModalOpen={setIsModalEditStatusOpen}
          companySelected={companyToEdit}
        />
      )}

      <CustomTable
        data={parseB3Table({
          data: dataArray,
          onStatusClick: handleSelectCompanyToEditStatus,
          onEditClick: handleSelectCompany,
          onDeleteClick: handleSelectCompanyToDelete,
        })}
        pagination={{
          currentPage,
          onPageChange,
          totalPages,
        }}
        autoHeight
      />
    </div>
  )
}

export default B3Table
